module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/step4-pict01-full-7f1b582bd5432a41fe3bb03c87bf8eb1.jpg";